import { useGameStore } from '../store/gameSlice';
import { openInterface } from './InterfaceService';
import { NPC_REGISTRY } from '../data/npcs.config';
import { NpcService } from '../types/npc.types';

function dispatchNpcService(service: NpcService): void {
  const { setGameplay, setCurrentShopId } = useGameStore.getState();
  switch (service.kind) {
    case 'open-screen':
    case 'open-interface':
      if (service.target) {
        openInterface(service.target);
      }
      break;
    case 'view-dungeon-map':
      setGameplay('dungeon-map');
      break;
    case 'view-bestiary':
      openInterface('bestiary');
      break;
    case 'view-shop':
      if (service.target) {
        setCurrentShopId(service.target);
        openInterface('shop');
      }
      break;
  }
}

/**
 * Opens a hub station's interface directly — no dialogue. Each station has a
 * single service; interacting fires it immediately.
 */
export function openNpc(npcId: string): void {
  const service = NPC_REGISTRY[npcId]?.services[0];
  if (service) {
    dispatchNpcService(service);
  }
}
